import { render, staticRenderFns } from "./ShortcutPreview.vue?vue&type=template&id=2158ee44&scoped=true"
import script from "./ShortcutPreview.vue?vue&type=script&lang=js"
export * from "./ShortcutPreview.vue?vue&type=script&lang=js"
import style0 from "./ShortcutPreview.vue?vue&type=style&index=0&id=2158ee44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158ee44",
  null
  
)

export default component.exports